import { useQuery } from 'react-query';

import type { PeriodJob } from 'state/remote/types';

type FreelancerAvailaleJobs = {
  data: Array<PeriodJob>;
  isLoading?: boolean;
  error: Error | null;
  refetch: (options: {
    throwOnError?: boolean;
    cancelRefetch?: boolean;
  }) => unknown;
};

const useGetFreelancerPeriodJobs = (
  isFilterEnabled: boolean,
  minRate: string,
  travelDistance: string,
  filterInitiated: boolean,
): FreelancerAvailaleJobs => {
  const getPeriodJobs = async () => {
    let response: Response;

    if (!isFilterEnabled) {
      response = await fetch('/api/period_jobs/');
    } else {
      const params = `min_rate=${minRate}&travel_distance=${travelDistance}`;
      response = await fetch(`/api/period_jobs/?${params}`);
    }
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  };
  const { isLoading, error, data, refetch } = useQuery<Array<PeriodJob>, Error>(
    ['get-freelancer-period-jobs', filterInitiated],
    getPeriodJobs,
  );

  return { data: data ?? [], error, isLoading, refetch };
};

export default useGetFreelancerPeriodJobs;
